// extracted by mini-css-extract-plugin
export var logo = "_hz-2";
export var logoWrapper = "_hz-1";
export var strip = "_hz-0";